export const right = (str: string, len: number, elipse = '') => {
  let s = String(str).trim();
  return elipse + s.slice(s.length - len - elipse.length);
};
